// src/utils/appReset/resetAppChatState.js

import {
  setSelectedChatId,
  setSelectedSocketLanguageData,
  setIsTextLanguageDetecting,
  setTextLanguageDetectionData,
  setIsContentGenerating,
  setContentGenerationData,
  setIsNerDetecting,
  setNerDetectionData,
  setIsSocketRecording,
  setAccumulatedFinalTranscript,
  setCurrentInterimTranscript,
  setDisplayTranscript,
  setRecordedBase64Data,
  deleteDataForVoiceLockFlow,
  deleteDataForTextLockFlow,
  setGrievanceFileData,
  setGrievanceAdditionalComments,
  setIsHideUserInputFields,
  setIsSuggestedQuestionsVisible,
  setIsNotRelatedToCenter,
  setIsGrievanceStatusFlowEnded,
} from "../../store/features/message/textContentSlice";

import {
  clearInputValue,
  setInputDisabled,
  setSendButtonDisabled,
  setMicButtonDisabled,
  setIsBigMicButtonClicked,
} from "../../store/features/ui/uiSlice";

import { clearChatConfig } from "../chatConfigStorage";

/**
 * HARD RESET – no business logic, no navigation, no flags
 */
export const resetAppChatState = ({
  dispatch,
  sharedApiService,
  setSelectedLanguageData,
}) => {
  try {
    // 9️⃣ Language (UI default)
    setSelectedLanguageData?.({ code: "en", label: "English" });
    // console.log("App chat state reset initiated");
    localStorage.setItem("selectedLanguage", JSON.stringify({ code: "en", label: "English" }));

    // 1️⃣ Cancel async work
    sharedApiService?.cancelAllRequests?.();

    // 2️⃣ Clear config
    clearChatConfig();

    // 3️⃣ Chat identity
    dispatch(setSelectedChatId(null));

    // 4️⃣ Input & voice
    dispatch(clearInputValue());
    dispatch(setAccumulatedFinalTranscript(""));
    dispatch(setCurrentInterimTranscript(""));
    dispatch(setDisplayTranscript(""));
    dispatch(setRecordedBase64Data(null));
    dispatch(setSelectedSocketLanguageData(null));

    // 5️⃣ Locks
    dispatch(deleteDataForVoiceLockFlow());
    dispatch(deleteDataForTextLockFlow());

    // 6️⃣ Async flags
    dispatch(setIsTextLanguageDetecting(false));
    dispatch(setTextLanguageDetectionData(null));
    dispatch(setIsContentGenerating(false));
    dispatch(setContentGenerationData(null));
    dispatch(setIsNerDetecting(false));
    dispatch(setNerDetectionData(null));
    dispatch(setIsSocketRecording(false));

    // 7️⃣ UI
    dispatch(setInputDisabled(false));
    dispatch(setSendButtonDisabled(false));
    dispatch(setMicButtonDisabled(false));
    dispatch(setIsHideUserInputFields(false));
    dispatch(setIsSuggestedQuestionsVisible(true));
    dispatch(setIsBigMicButtonClicked(false));

    // 8️⃣ Grievance
    dispatch(setGrievanceFileData(null));
    dispatch(setGrievanceAdditionalComments(""));

    // 9️⃣ Reset notRelatedToCenter flag
    dispatch(setIsNotRelatedToCenter(false));

    // 🔟 Reset grievance status flow ended flag
    dispatch(setIsGrievanceStatusFlowEnded(false));
  } catch (error) {
    console.log("Error is: ", error);
  }
};
